import { FeatureDTO } from "./FeatureDTO";

export class VideoUploadFeatureDTO extends FeatureDTO {
    constructor(sub?) {
        super(sub);
    }
}
